import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Smartphone } from "lucide-react";

/**
 * Invitación del estado vacío del inbox a vincular un número. Los números se
 * vinculan en UN solo lugar —Configuración → Integraciones → Canales de
 * comunicación—, así que el inbox manda allá en vez de abrir su propio QR y
 * crear un número por su cuenta (mismo destino que "Revisar canales" de la
 * lista y que la página de canales de la mesa de ayuda).
 */
export default function LinkWhatsAppHint() {
  const { t } = useTranslation();
  return (
    <div className="mt-6 pt-6 border-t border-border/60 flex flex-col items-center">
      <p className="max-w-sm text-xs text-fg-subtle">
        {t("¿Aún no recibes mensajes? Vincula un número de WhatsApp para empezar a atender la mesa de ayuda.")}
      </p>
      <Link
        to="/admin/settings?tab=integrations&sub=channels"
        className="hd-brand-solid mt-3 inline-flex items-center gap-1.5 h-11 md:h-9 px-3.5 rounded-md text-sm font-medium bg-brand-500 text-white no-underline hover:bg-brand-600 active:bg-brand-700 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2"
      >
        <Smartphone className="w-4 h-4" aria-hidden="true" />
        {t("Vincular WhatsApp en Integraciones")}
      </Link>
    </div>
  );
}
